import * as yup from 'yup';



export const EMAIL_MAX_LENGTH = 200;


// ------ validations

export const SCHEMA_EMAIL = yup.string()
    .nullable()
    .email()
    .max(EMAIL_MAX_LENGTH)
    .required();
